<template>
  <div>
    <b-row>
      <b-col md="12" class="card-name">
        <div v-for="(item, index) in form.intent" v-bind:key="index">
          <div
            v-bind:class="[languageActiveId == item.language ? '' : 'd-none']"
          >
            <InputText
              textFloat="Intent Name"
              placeholder="Intent Name"
              type="text"
              name="cardName"
              isRequired
              v-model="item.name"
              :isValidate="v.form.intent.$each.$iter[index].name.$error"
              :v="v.form.intent.$each.$iter[index].name"
            />
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" class="card-name">
        <div v-for="(item, index) in form.intent" v-bind:key="index">
          <div
            v-bind:class="[languageActiveId == item.language ? '' : 'd-none']"
          >
            <InputText
              textFloat="Intent Suggest"
              placeholder="Intent Suggest"
              type="text"
              name="intentSuggest"
              v-model="item.suggest"
            />
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <InputSelect
          title="Intent Type"
          name="IntentType"
          isRequired
          v-model="form.intentTypeId"
          :options="intentTypeList"
          valueField="id"
          textField="name"
          @onDataChange="onIntentTypeChange"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <InputSelect
          title="API Config"
          name="apiConfig"
          v-model="form.apiConfigId"
          :options="apiConfigList"
          valueField="id"
          textField="name"
          @onDataChange="onApiConfigChange"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <InputSelect
          title="Set Tier"
          name="setTeir"
          v-model="form.setTierId"
          :options="tierMasterdataList"
          valueField="id"
          textField="name"
          @onDataChange="onSetTeirChange"
        />
      </b-col>
    </b-row>
    <b-row> 
      <b-col>
        <IntentVariableForm 
          ref="intentVariableForm"
          :form="form"
          :v="v"
        />
      </b-col>
    </b-row>
    <b-row class="mb-2">
      <b-col>
        <b-form-group label="Channel" class="m-0" v-slot="{ ariaDescribedby }">
          <b-form-checkbox
            v-for="option in channelList"
            v-model="form.channel"
            :key="option.id"
            :value="option.id"
            :aria-describedby="ariaDescribedby"
            :disabled="intentLevel > 0 && form.mainIntentId == 0"
            name="flavour-3a"
            class="my-1"
          >
            {{ option.name }}
          </b-form-checkbox>
        </b-form-group>
        <div v-if="v && v.form.channel.$error" class="text-error mt-1">
          กรุณาเลือกอย่างน้อย 1 ตัวเลือก
        </div>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col>
        <b-form-group label="Tier" class="m-0" v-slot="{ ariaDescribedby }">
          <b-form-checkbox
            v-for="option in tierList"
            v-model="form.tier"
            :key="option.id"
            :value="option.id"
            :disabled="intentLevel > 0 && form.mainIntentId == 0"
            :aria-describedby="ariaDescribedby"
            name="flavour-3a"
            class="my-1"
          >
            {{ option.name }}
          </b-form-checkbox>
        </b-form-group>
        <div v-if="v && v.form.tier.$error" class="text-error mt-1">
          กรุณาเลือกอย่างน้อย 1 ตัวเลือก
        </div>
      </b-col>
    </b-row>
    <div v-for="(item, index) in form.intent" v-bind:key="'keyword-' + index">
      <div v-bind:class="[languageActiveId == item.language ? '' : 'd-none']">
        <KeywordForm
          :keywordList="item.keyword"
          :showKeywordLength="15"
          :v="v.form.intent.$each.$iter[index].keyword"
          :showAllList="showAllKeyword"
          :showImportKeyword="true"
          v-on:onImportKeyword="onImportKeyword"
          v-on:setShowAllKeyword="setShowAllKeyword"
        />
      </div>
    </div>
    <b-row class="mt-3">
      <b-col>
        <ImageTrainingUpload
          :v="v.form.image"
          v-bind:dataList="form.image"
          @handleChangeImageList="handleChangeImageList"
        />
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col>
        <b-form-checkbox class="mb-1" v-model="form.forwardToAgent"
          >Forward To Agent</b-form-checkbox
        >
        <!-- <b-form-checkbox v-model="isSentiment" @change="$emit('setIsSentiment')"
          >Sentiment</b-form-checkbox
        > -->
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col class="p-0 panel-sentiment">
        <b-button-group class="w-100 px-3 btn-sentiment py-2">
          <b-button
            :class="[{ active: sentimentActiveId == 1 }]"
            @click="$emit('setSentimentActive', 1)"
            >Nuetral</b-button
          >
          <b-button
            :class="[{ active: sentimentActiveId == 2 }]"
            @click="$emit('setSentimentActive', 2)"
            >Negative</b-button
          >
        </b-button-group>
      </b-col>
    </b-row>
    <template v-if="forceRefresh">
      <div v-for="(item, index) in form.intent" v-bind:key="index">
        <div v-bind:class="[languageActiveId == item.language ? '' : 'd-none']">
          <b-row v-if="sentimentActiveId == 2" class="mt-3">
            <b-col>
              <b-form-checkbox
                class=""
                v-model="item.sameReplyAsNeutral"
                @change="onSameReplyAsNeutralChange(index)"
                >Same reply as Nuetral</b-form-checkbox
              >
            </b-col>
          </b-row>
          <div>
            <template v-if="sentimentActiveId == 1">
              <b-row class="mt-3">
                <b-col>
                  <span class="reply-tag">Reply</span>
                </b-col>
                <b-col class="text-right">
                  <u
                    class="text-main-color pointer"
                    @click="onAddResponse(index)"
                    v-if="item.neutralReply.length < 5"
                    >Add</u
                  >
                  <u class="text-secondary-color" v-else>Add</u>
                </b-col>
              </b-row>
              <b-row
                v-for="(response, rindex) in item.neutralReply"
                :key="rindex"
                class="reply-box mt-2 shadow"
              >
                <b-col class="py-2">
                  <div class="d-flex my-2">
                    <div class="reply-text">Reply # {{ rindex + 1 }}</div>
                    <div class="ml-auto" v-if="item.neutralReply.length > 1">
                      <font-awesome-icon
                        @click="onDeleteResponse(index, rindex)"
                        icon="trash-alt"
                        class="pointer text-danger"
                      />
                    </div>
                  </div>
                  <div class="mt-3">
                    <ResponseForm
                      :response="response"
                      :languageActiveId="languageActiveId"
                      :sameReplyAsNeutral="item.sameReplyAsNeutral"
                      :v="
                        v.form.intent.$each.$iter[index].neutralReply.$each
                          .$iter[rindex]
                      "
                      class="response-form"
                    />
                  </div>
                </b-col>
              </b-row>
            </template>

            <template v-if="sentimentActiveId == 2 && !item.sameReplyAsNeutral">
              <b-row class="mt-3">
                <b-col>
                  <span class="reply-tag">Reply Negative</span>
                </b-col>
                <b-col class="text-right">
                  <u
                    class="text-main-color pointer"
                    @click="onAddResponse(index)"
                    v-if="item.negativeReply.length < 5"
                    >Add</u
                  >
                  <u class="text-secondary-color" v-else>Add</u>
                </b-col>
              </b-row>
              <b-row
                v-for="(response, rindex) in item.negativeReply"
                :key="rindex"
                class="reply-box mt-2 shadow"
              >
                <b-col class="py-2">
                  <div class="d-flex my-2">
                    <div class="reply-text">Reply # {{ rindex + 1 }}</div>
                    <div class="ml-auto" v-if="item.negativeReply.length > 1">
                      <font-awesome-icon
                        @click="onDeleteResponse(index, rindex)"
                        icon="trash-alt"
                        class="pointer text-danger"
                      />
                    </div>
                  </div>
                  <div class="mt-3">
                    <ResponseForm
                      :response="response"
                      :languageActiveId="languageActiveId"
                      :sameReplyAsNeutral="item.sameReplyAsNeutral"
                      :v="
                        v.form.intent.$each.$iter[index].negativeReply.$each
                          .$iter[rindex]
                      "
                      class="response-form"
                    />
                  </div>
                </b-col>
              </b-row>
            </template>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
import KeywordForm from "@/views/pages/flow-builder/components/sidebar/KeywordForm";
import ResponseForm from "@/views/pages/flow-builder/components/sidebar/ResponseForm";
import ImageTrainingUpload from "@/views/pages/flow-builder/components/sidebar/ImageTrainingUpload";
import IntentVariableForm from "./IntentVariableForm.vue"

export default {
  components: {
    InputText,
    InputSelect,
    KeywordForm,
    ResponseForm,
    ImageTrainingUpload,
    IntentVariableForm
  },
  props: {
    form: {
      required: true,
      type: Object,
    },
    v: {
      required: true,
      type: Object,
    },
    showAllKeyword: {
      required: false,
      type: Boolean,
    },
    languageActiveId: {
      required: false,
      type: Number,
    },
    channelList: {
      required: true,
      type: Array,
    },
    tierList: {
      required: true,
      type: Array,
    },
    sentimentActiveId: {
      required: false,
      type: Number,
    },
    isSentiment: {
      required: false,
      type: Boolean,
    },
    intentLevel: {
      required: false,
      type: Number,
    },
  },
  data() {
    return {
      activeSentiment: 1,
      selected: [],
      selected2: [],
      keywordList: [],
      refreshKeywordModal: true,
      forceRefresh: true,
    };
  },
  created: async function () {
    this.scrollToEnd();
  },
  computed: {
    ...mapGetters({ tierMasterdataList: 'flowBuilder/getTierMasterdataList' }),
    ...mapGetters({ intentTypeList: 'flowBuilder/getIntentTypeList' }),
    ...mapGetters({ apiConfigList: 'flowBuilder/getApiConfigList' }),
    ...mapGetters({ variableList: 'flowBuilder/getVariableList' })
  },
  methods: {
    onRefreshForm() {
      this.forceRefresh = false;
      this.$nextTick(() => {
        this.forceRefresh = true;
      });
    },
    onImportKeyword(keywordList) {
      let index = this.form.intent.findIndex(
        (el) => el.language == this.languageActiveId
      );
      this.form.intent[index].keyword = keywordList;
    },
    onIntentTypeChange(val) {
      this.$emit("onIntentTypeChange", val);
    },
    onApiConfigChange(val) {
      this.$emit("onApiConfigChange", val);
    },
    onSetTeirChange(val) {
      this.$emit("onSetTeirChange", val);
    },
    onSameReplyAsNeutralChange(intentIndex) {
      // this.form.intent[intentIndex].sameReplyAsNeutral =
      //   !this.form.intent[intentIndex].sameReplyAsNeutral;
      this.setSameReplyAsNuetral();
    },
    setSameReplyAsNuetral() {
      //NuetralReply
      this.form.intent.forEach((intent) => {
        intent.neutralReply.forEach((neutral) => {
          if (neutral.content.Text) {
            neutral.content.Text.sameReplyAsNeutral = intent.sameReplyAsNeutral;
          }
          if (neutral.content.Image) {
            if (neutral.content.ReplyType == 4) {
              neutral.content.Image.forEach((element) => {
                element.sameReplyAsNeutral = intent.sameReplyAsNeutral;
              });
            } else {
              neutral.content.Image.sameReplyAsNeutral =
                intent.sameReplyAsNeutral;
            }
          }
          if (neutral.content.Button) {
            neutral.content.Button.forEach((button) => {
              button.sameReplyAsNeutral = intent.sameReplyAsNeutral;
            });
          }
          if (neutral.content.ReplyType == 4) {
            neutral.content.sameReplyAsNeutral = intent.sameReplyAsNeutral;
          }
        });
        //NegativeReply
        intent.negativeReply.forEach((neutral) => {
          if (neutral.content.Text) {
            neutral.content.Text.sameReplyAsNeutral = intent.sameReplyAsNeutral;
          }
          if (neutral.content.Image) {
            if (neutral.content.ReplyType == 4) {
              neutral.content.Image.forEach((element) => {
                element.sameReplyAsNeutral = intent.sameReplyAsNeutral;
              });
            } else {
              neutral.content.Image.sameReplyAsNeutral =
                intent.sameReplyAsNeutral;
            }
          }

          if (neutral.content.Button) {
            neutral.content.Button.forEach((button) => {
              button.sameReplyAsNeutral = intent.sameReplyAsNeutral;
            });
          }
          if (neutral.content.ReplyType == 4) {
            neutral.content.sameReplyAsNeutral = intent.sameReplyAsNeutral;
          }
        });
      });
    },
    handleChangeImageList(imageList) {
      this.form.image = imageList;
    },
    setShowAllKeyword() {
      this.$emit("setShowAllKeyword");
    },
    scrollToEnd: function () {
      var container = document.getElementsByClassName("response-form");
      setTimeout(() => {
        container[container.length - 1].scrollIntoView(false);
      }, 0);
    },
    onAddResponse(intentIndex) {
      let reply = {
        id: 0,
        sortOrder: 0,
        content: {
          ReplyType: 1,
          Text: {
            Id: 0,
            Text: "",
            language: this.languageActiveId,
            sameReplyAsNeutral:
              this.form.intent[intentIndex].sameReplyAsNeutral,
          },
        },
      };
      if (this.sentimentActiveId == 1) {
        reply.sortOrder = this.form.intent[intentIndex].neutralReply.length + 1;
        this.form.intent[intentIndex].neutralReply.push(reply);
      } else {
        reply.sortOrder =
          this.form.intent[intentIndex].negativeReply.length + 1;
        this.form.intent[intentIndex].negativeReply.push(reply);
      }

      // this.scrollToEnd();
    },
    async onDeleteResponse(intentIndex, replyIndex) {
      if (this.sentimentActiveId == 1) {
        await this.form.intent[intentIndex].neutralReply.splice(replyIndex, 1);
        this.form.intent[intentIndex].neutralReply.forEach((element, index) => {
          element.sortOrder = index + 1;
        });
      } else {
        await this.form.intent[intentIndex].negativeReply.splice(replyIndex, 1);
        this.form.intent[intentIndex].negativeReply.forEach(
          (element, index) => {
            element.sortOrder = index + 1;
          }
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.reply-text {
  color: #7160c4;
}

.btn-sentiment > button {
  color: #424242;
  background-color: white;
  border-radius: 6px;
  margin: 0 0 0 5px;
  height: 35px;
  padding: 5px 10px;
}

.btn-sentiment > button.active,
.btn-sentiment > button:hover {
  color: white !important;
  background-color: #7160c4 !important;
  border-color: #7160c4;
}

.panel-sentiment {
  background: #f1f1f1;
}

.keyword-tag,
.reply-tag {
  color: #242424;
  font-size: 16px;
  margin-bottom: 2px;
  font-weight: bold;
}
.text-main-color {
  color: #242424;
}
.text-secondary-color {
  color: #bebebe;
}
#your_div {
  height: 100%;
  overflow: auto;
}
.reply-box {
  margin: 1px;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-clip: border-box;
  border: 1px solid;
  border-radius: 0.25rem;
  background-color: #e2dff3;
  border-color: #e2dff3;
}
.text-error {
  color: #ff0000;
  font-size: 14px;
}
::v-deep .form-group legend.col-form-label {
  font-weight: 700 !important;
  padding-bottom: 0 !important;
}
::v-deep {
  .input-custom > label,
  .select-custom > label {
    color: #242424 !important;
  }
  .button-box {
    .input-custom > label,
    .select-custom > label,
    ::-webkit-input-placeholder,
    ::-ms-input-placeholder,
    ::placeholder,
    .custom-input > input {
      font-size: 14px !important;
    }
  }
}
</style>
